import React, { useEffect, useState } from "react";
//import logo from "../../assets/logo/webscript.png";
import logo from "../../assets/logo/sura.png";
import { Auth } from 'recupero-comunes';
import MenuItem from "./menu-item";
import MonitorSesion from "./monitor-sesion";
import { useIdleTimer } from 'react-idle-timer';


const SideMenu = (props) => {

    const [inactive, setInactive] = useState(props.inactiveSide);
    const [message, setMessage] = useState("");
    const [intervalId, setIntervalId] = useState();
    const [timeOutId, setTimeOutId] = useState();

    const handleOnIdle = (event) => {
        let tiempoAviso = 0.25;
        //console.log('tiempoAviso', tiempoAviso);
        let ms = 1000 * 60 * tiempoAviso;
        let interval = startCountdown(ms);
        let timeOut = setTimeout(() => {
            Promise.resolve(clearInterval(interval)).then(props.onLogout());
        }, ms);

        setIntervalId(interval);
        setTimeOutId(timeOut);
        setMessage("Su sesión se cerrará en " + ms/1000 + " segundos");
    }

    const handleOnActive = (event) => {
        //console.log('user is active', event);
            reset();
    }

    const handleOnAction = event => {
        //console.log('user did something', event);
    }

    const handleAccept = () => {
        setMessage("");
        clearInterval(intervalId);
        clearTimeout(timeOutId);
    }

    const handleCancel = () => {
        setMessage("");
        clearInterval(intervalId);
		clearTimeout(timeOutId);
		props.onLogout();
    }

    const { reset } = useIdleTimer({
        timeout: 1000 * 60 * 60, // 1000 * 60 * 1 = 1min
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        onAction: handleOnAction,
        debounce: 250
    });

    const startCountdown = (ms) => {

		let interval = setInterval(()=>{
			if (ms >= 0) {
				//('setInterval!', ms);
				setMessage("Su sesión se cerrará en " + ms/1000 + " segundos.");
				ms = ms -1000;
			} else {
				clearInterval(interval);
			}

		},1000);
		return interval;
	}

    useEffect(() => {
        if (props.inactiveSide) {
            removeActiveClassFromSubMenu();
        }

        props.onCollapse(props.inactiveSide);
    }, [props]);

    const removeActiveClassFromSubMenu = () => {
        document.querySelectorAll(".sub-menu").forEach((el) => {
            el.classList.remove("active");
        });
    };

    useEffect(() => {
        let menuItems = document.querySelectorAll(".menu-item");
        menuItems.forEach((el) => {
            el.addEventListener("click", (e) => {
                const next = el.nextElementSibling;
                removeActiveClassFromSubMenu();
                menuItems.forEach((el) => el.classList.remove("active"));
                el.classList.toggle("active");
                //console.log(next);
                if (next !== null) {
                    next.classList.toggle("active");
                }
            });
        });
    }, []);

    return (
        <>
        <MonitorSesion show={message!==""} message={message} accept={() => handleAccept()} cancel={() => handleCancel()} />
        <div className={`side-menu ${props.inactiveSide ? "inactive" : ""}`}>

            <div className="top-section" align="center">
                <div className={ props.inactiveSide ? "logo-sm" : "logo" }>
                    <img src={logo} className="img-thumbnail" alt="webscript" />
                </div>
                { !props.inactiveSide && ( <p className="fs-6 text-muted mt-4 mb-4">{Auth.currentUser()?.nombre_organizacion}</p> ) }
            </div>

            <div className="divider"></div>

            <div className="main-menu">
                <ul>
                    {
                    Auth.currentUser()?.opcionesMenu.map((menuItem, index) => (
                        <MenuItem
                            key={index}
                            name={menuItem.name}
                            to={menuItem.to}
                            subMenus={menuItem.subMenus || []}
                            iconClassName={menuItem.iconClassName}
                            onClick={(e) => {
                                if (inactive) {
                                    setInactive(false);
                                }
                            }}
                        />
                    ))}
                </ul>
            </div>
        </div>
        </>
    );
};

export default SideMenu;
